import ReduxSaga, { Task } from 'redux-saga';
import HashTable from './hashTable';
import type { Saga0 } from './interface';

const hashTable = new HashTable<Saga0, Task>();
const sagaMiddleWare = ReduxSaga({});

export function runSaga(saga: Saga0) {
    let task = hashTable.get(saga);
    if (task) {
        task.cancel();
    }
    task = sagaMiddleWare.run(saga);
    hashTable.put(saga, task);
}

export default sagaMiddleWare;
